import { useMutation, UseMutationOptions } from "react-query"
import api from "services/api"

export interface ConfirmEmailChangeParams {
  user: string
  email: string
  signature: string
  expires: string
}

export function useConfirmEmailChange(
  config?: UseMutationOptions<unknown, unknown, ConfirmEmailChangeParams>
) {
  return useMutation<unknown, unknown, ConfirmEmailChangeParams>(
    (params) =>
      api.post("account/email-change/confirm", undefined, {
        params: {
          email: params.email,
          expires: params.expires,
          user: params.user,
          signature: params.signature,
        },
      }),
    config
  )
}
